import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const orderRoutes: RouteConfig = {
  path: '/order',
  component: Layout,
  meta: {
    title: 'orderMgt',
    icon: 'table'
    // alwaysShow: true
  },
  children: [
    {
      path: 'depositList',
      name: 'Deposit Order',
      component: () => import('@/views/order/depositList.vue'),
      meta: {
        // title: 'depositList',
        title: 'deposit',
        icon: 'excel',
        activeMenu: '/order/depositList'
      }
    },
    {
      path: 'payoutList',
      name: 'Payout Order',
      component: () => import('@/views/order/payoutList.vue'),
      meta: {
        // title: 'payoutList',
        title: 'payout',
        icon: 'documentation',
        activeMenu: '/order/payoutList'
      }
    },
    {
      path: 'settlementList',
      name: 'Settlement Order',
      component: () => import('@/views/order/settlementList.vue'),
      meta: {
        // title: 'settlementList',
        title: 'settlement',
        icon: 'skill',
        activeMenu: '/order/settlementList'
      }
    },
    {
      path: 'refund',
      name: 'Refund Order',
      component: () => import('@/views/order/refund.vue'),
      meta: {
        // title: 'refund',
        title: 'refund',
        icon: 'zhichu',
        activeMenu: '/order/refund'
      }
    },
    {
      path: 'requestLog',
      name: 'Request Log',
      component: () => import('@/views/order/requestLog.vue'),
      meta: {
        // title: 'settlementList',
        title: 'requestLog',
        icon: 'documentation',
        activeMenu: '/order/requestLog'
      }
    },
    {
      path: 'topupOrder',
      name: 'TopupOrder',
      component: () => import('@/views/order/topupOrder.vue'),
      meta: {
        title: 'topupOrder',
        icon: 'education',
        activeMenu: '/order/topupOrder'
      }
    },
    {
      path: 'cashOrder',
      name: 'CashOrder',
      component: () => import('@/views/order/cashOrder.vue'),
      meta: {
        title: 'cashOrder',
        icon: 'money',
        activeMenu: '/order/cashOrder'
      }
    },
    {
      path: 'buyUOrder',
      name: 'buy U Order',
      component: () => import('@/views/order/buyUOrder.vue'),
      meta: {
        title: 'buyUOrder',
        icon: 'bug',
        activeMenu: '/order/buyUOrder'
      }
    },
    {
      path: 'exchangeOrder',
      name: 'Exchange Order',
      component: () => import('@/views/order/exchangeOrder.vue'),
      meta: {
        title: 'exchangeOrder',
        icon: 'list',
        activeMenu: '/order/exchangeOrder'
      }
    },
    {
      path: 'globalPayments',
      name: 'global payments',
      component: () => import('@/views/order/globalPayments.vue'),
      meta: {
        title: 'globalPayments',
        icon: 'international',
        activeMenu: '/order/globalPayments'
      }
    }
  ]
}

export default orderRoutes
